var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "targetRef" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            {
              ref: "queryFormRef",
              staticClass: "queryFormClass",
              attrs: {
                model: _vm.queryForm,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "时效类型：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择", clearable: "" },
                              on: { change: _vm.handleSearchAgingTypeChange },
                              model: {
                                value: _vm.queryForm.params.agingType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "agingType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.agingType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "客户派送时效", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "客户闭环时效", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "内部网点时效", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                remote: "",
                                clearable: "",
                                placeholder: "请输入并搜索",
                                "remote-method": _vm.searchCustomerList,
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.searchCustomerList("")
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.customerId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "customerId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.customerId",
                              },
                            },
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.username, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "渠道：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.channelCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "channelCode",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.channelCode",
                              },
                            },
                            _vm._l(_vm.channelList, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "网点：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.siteId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "siteId", $$v)
                                },
                                expression: "queryForm.params.siteId",
                              },
                            },
                            _vm._l(_vm.siteList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "时效ID：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请输入时效ID",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.slaId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "slaId",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryForm.params.slaId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "刷新状态：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择", clearable: "" },
                              model: {
                                value: _vm.queryForm.params.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "status", $$v)
                                },
                                expression: "queryForm.params.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "待执行", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "执行中", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "已完成", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "部分完成", value: 3 },
                              }),
                              _c("el-option", {
                                attrs: { label: "执行失败", value: 4 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { type: "flex", justify: "start" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh", size: "mini" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "150",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("parseTime")(scope.row.createTime))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "客户 / 渠道 / 网点",
                  "min-width": "150",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.agingType === 2
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: scope.row.customerName || "- -",
                                      effect: "dark",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "site-names-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.customerName || "- -"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.customerName ||
                                    scope.row.channelCode ||
                                    "- -"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "agingType",
                  label: "时效类型",
                  "min-width": "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.agingType === 0
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("客户派送时效"),
                            ])
                          : scope.row.agingType === 1
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("客户闭环时效"),
                            ])
                          : scope.row.agingType === 2
                          ? _c("el-tag", { attrs: { type: "warning" } }, [
                              _vm._v("内部网点时效"),
                            ])
                          : scope.row.agingType === 3
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("内部大区时效"),
                            ])
                          : _c("span", [_vm._v("- -")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "slaId",
                  label: "使用的时效ID",
                  "min-width": "140",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "slaVersion",
                  label: "使用的时效版本",
                  "min-width": "110",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            "V" +
                              _vm._s(_vm.formatVersion(scope.row.slaVersion))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "刷新范围",
                  "min-width": "260",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(scope.row.refreshStartTime)
                            ) +
                              " 至 " +
                              _vm._s(
                                _vm._f("parseTime")(scope.row.refreshEndTime)
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "refreshCount",
                  label: "刷新数据量",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.refreshCount != null
                                ? scope.row.refreshCount
                                : "- -"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "completedEndTime",
                  label: "完成进度",
                  "min-width": "210",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getProgressText(scope.row))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "刷新状态",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", effect: "dark" } },
                              [_vm._v("待执行")]
                            )
                          : scope.row.status === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "primary", effect: "dark" } },
                              [_vm._v("执行中")]
                            )
                          : scope.row.status === 2
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", effect: "dark" } },
                              [_vm._v("已完成")]
                            )
                          : scope.row.status === 3
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", effect: "dark" } },
                              [_vm._v("部分完成")]
                            )
                          : scope.row.status === 4
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", effect: "dark" } },
                              [_vm._v("执行失败")]
                            )
                          : _c("span", [_vm._v("- -")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createUserName",
                  label: "创建人",
                  "min-width": "110",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 3 || scope.row.status === 4
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  icon: "el-icon-refresh-left",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRetry(scope.row)
                                  },
                                },
                              },
                              [_vm._v("重试")]
                            )
                          : _c("span", [_vm._v("- -")]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "pagination-container",
              staticStyle: { "margin-top": "15px", "text-align": "right" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }